import { ProductPageItemFragment } from '@graphcommerce/magento-product'
import { Trans } from '@lingui/react'

export type PrintTemplatesProps = Pick<ProductPageItemFragment, 'amfiles'>

export function PrintTemplates(props: PrintTemplatesProps) {
  const { amfiles } = props

  return (
    <div className='mx-[40px]'>
      <h3 className='Type-XXL-Bold'>
        <Trans id='Print Templates' />
      </h3>
      {amfiles && amfiles?.length > 0 && (
        <div className='mt-5 flex flex-col gap-5 overflow-y-auto bg-lighter-gray px-10 py-4'>
          {amfiles?.map((file) => (
            <a href={file?.url || '#'} className='inline-block' target='_blank' rel='noreferrer'>
              <div
                key={file?.file_id}
                className='Type-Large-Regular rounded-[5px] border-[1.5px] border-dotted border-light-gray bg-5-grey px-[35px] py-[10px] hover:bg-[#6133941A] hover:text-material-ui-blue'
              >
                {file?.label}
              </div>
            </a>
          ))}
        </div>
      )}
    </div>
  )
}
